module.exports = __webpack_public_path__ + "img/express-underground-belt-structure.587754bf.png";